import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import cls from './SucсessPage.module.scss';
import sberLogo from '@/shared/assets/icons/sberLogoBig.svg';
import { useAcquiringStore } from '../../model/store/useAcquiringStore';

const FailPage = () => {
    const { setIsAcquiring } = useAcquiringStore();

    useEffect(() => {
        setIsAcquiring(true);
        return () => setIsAcquiring(false);
    }, []);

    return (
        <div className={cls.wrapper}>
            <img className={cls.image} src={sberLogo} alt="" />
            <h3>Что-то пошло не так</h3>
            <p>Страховой полис по вашему договору страхования не оформлен, обратитесь к менеджеру банка</p>
            <Link to="https://sberbank-insurance.ru/" className={cls.btn}>
                Вернуться на главную
            </Link>
        </div>
    );
};

export default FailPage;
